export default function getHeaders(token: string): { Authorization: string } {
  return { Authorization: 'Bearer ' + token };
}
